import LegalDocPage from '@/components/LegalDocPage';

const TermsOfService = () => <LegalDocPage documentType="terms" title="Terms of Service" />;

export default TermsOfService;
